module.exports = __webpack_public_path__ + "carousel_01_img_05.jpg?b71498cebd4669df73e8bf1f2e13b48e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel_01_img_05.jpg
// module id = 145
// module chunks = 0